module.exports = __webpack_public_path__ + "media/images/favicons/favicon-32x32-d51ea33e8d902449d2049cee2c232b77.png";